/** 
 * @type {ProjectsFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: [],
    names: null,
    country_ids: [],
    region_ids: [],
    asset_ids: [],
    status: [],
}
/** 
* @returns {ProjectsFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/ProjectsFilter.js